import { createRouter, createWebHashHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: { layout: 'main-page' },
    component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue'),
  },
  {
    path: '/creditos',
    name: 'Credits',
    component: () => import('../views/Credits.vue'),
  },
  {
    path: '/directorio',
    name: 'Directory',
    component: () => import('../views/Directory.vue'),
  },
];

const router = createRouter({
  mode: 'history',
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      const element = document.querySelector(to.hash);
      return window.scroll({
        top: element.offsetTop - 95,
        left: 0,
        behavior: 'smooth',
      });
    }
    return window.scroll(0, 0);
  },
});

export default router;
